import { useEffect, useMemo, useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import ProductCard from "./ProductCard";
import { useLazyFilterProductsQuery } from "../../store/services/homeProducts";
import { toPersianNumber } from "../../utils/persian";

const getProductId = (product) => product?._id || product?.id || product?.slug;

const MobileAppendProducts = ({ initialProducts = [], count = 0, perPage = 12, queryParams = {}, resetKey = "" }) => {
  const [items, setItems] = useState(initialProducts);
  const [loadedPage, setLoadedPage] = useState(Number(queryParams.page || 1));
  const [trigger, { isFetching }] = useLazyFilterProductsQuery();

  const totalPages = Math.ceil(Number(count || 0) / Number(perPage || 1));
  const hasMore = loadedPage < totalPages;

  const stableResetKey = useMemo(() => resetKey, [resetKey]);

  useEffect(() => {
    setItems(initialProducts || []);
    setLoadedPage(Number(queryParams.page || 1));
  }, [stableResetKey, initialProducts, queryParams.page]);

  const loadMore = async () => {
    if (!hasMore || isFetching) return;

    const nextPage = loadedPage + 1;
    const response = await trigger({
      ...queryParams,
      page: nextPage
    });

    const nextProducts = response?.data?.products || [];

    setItems((prev) => {
      const existing = new Set(prev.map(getProductId));

      return [
        ...prev,
        ...nextProducts.filter((product) => !existing.has(getProductId(product)))
      ];
    });

    setLoadedPage(nextPage);
  };

  if (!items.length) {
    return null;
  }

  return (
    <div className="product-append-mobile">
      <div className="product-grid">
        {items.map((product, index) => (
          <ProductCard product={product} index={index} key={getProductId(product)} />
        ))}
      </div>

      <div className="mobile-load-more-box">
        <span>
          نمایش {toPersianNumber(items.length)} از {toPersianNumber(count)} محصول
        </span>

        {hasMore ? (
          <button type="button" onClick={loadMore} disabled={isFetching}>
            <FiChevronDown size={17} />
            <strong>{isFetching ? "در حال بارگذاری..." : "نمایش محصولات بیشتر"}</strong>
          </button>
        ) : (
          <p>همه محصولات این بخش نمایش داده شد</p>
        )}
      </div>
    </div>
  );
};

export default MobileAppendProducts;
